export const WISHLIST_API_PATHS = {
  root: '/wishlist',
  productIds: '/wishlist/product-ids',
  item: (productId: string) => `/wishlist/${encodeURIComponent(productId)}`,
} as const

export const WISHLIST_PATHS = {
  page: '/wishlist',
} as const

export const WISHLIST_UI = {
  pageTitle: 'Wishlist',
  itemSingular: 'item',
  itemPlural: 'items',
  emptyTitle: 'Your wishlist is empty',
  emptyHint: 'Save flowers and gifts you love — they will show up here.',
  emptyLoginTitle: 'Sign in to see your wishlist',
  emptyLoginHint: 'Wishlist items are saved to your account.',
  continueShopping: 'Continue shopping',
  loginCta: 'Sign in',
  remove: 'Remove',
  addToCart: 'Add to cart',
  headerLabel: 'Wishlist',
  addAria: 'Add to wishlist',
  removeAria: 'Remove from wishlist',
  loadingAria: 'Loading wishlist',
} as const
